export const BASE_URL = "https://api.unsplash.com";

export const API_KEY = process.env.REACT_APP_CLIENT_ACCESS_KEY;

export const SEARCH_URL = `https://api.unsplash.com/search/photos/?per_page=30&client_id=${API_KEY}`;

export const SINGLE_PHOTO_URL = ` https://api.unsplash.com/photos`;

export const IMAGE_URL = `https://images.unsplash.com`;

export const ENDPOINTS = [
  {
    id: "51517718",
    title: "Wallpaper",
    endpoint: `/collections/51517718/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1494472155656-f34e81b17ddc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTkzMjE&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Free stunning wallpapers for your mobile and desktop screens.",
  },
  {
    id: "543595",
    title: "Editorial",
    endpoint: `/collections/543595/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1584247740248-d728497a6f8c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk0MDg&ixlib=rb-1.2.1&q=80&w=1080",
    description: "A collection of curated photos.",
  },
  {
    id: "3348849",
    title: "Architecture",
    endpoint: `/collections/3348849/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1544173486-6bb9e45041a7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk0NjU&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "From towering skyscrapers to minimalist home decor, this category showcases the best of architectures and interiors.",
  },
  {
    id: "402491",
    title: "People",
    endpoint: `/collections/895838/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1622502860158-cf8832e7f784?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk1MjU&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Real people, captured. Photography has the power to give voice to individuals and groups within our communities.",
  },
  {
    id: "3356631",
    title: "Current Events",
    endpoint: `/collections/3356631/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1571811404701-50d168d30555?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk1NzU&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Covering the latest important and news-worthy moments from around the world — from political protests to cultural celebrations.",
  },
  {
    id: "3356576",
    title: "Fashion",
    endpoint: `/collections/3356576/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1589125703066-5da8ad0c2cdb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk2MTc&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "From street-style shots to editorial photography — find the latest trends in beauty and fashion.",
  },
  {
    id: "907185",
    title: "Technology",
    endpoint: `/collections/907185/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1632955422535-8ba21c5b8744?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk3MTU&ixlib=rb-1.2.1&q=80&w=1080",
    description: "Technology, Computers, Work, Marketing, School, College",
  },
  {
    id: "3633903",
    title: "Photography",
    endpoint: `/collections/3633903/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1455793067932-146d5b4a694f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk3NTY&ixlib=rb-1.2.1&q=80&w=1080",
    description: "The art of capturing light with a camera,",
  },
  {
    id: "1785728",
    title: "Travel",
    endpoint: `/collections/1785728/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1630872146677-5a4cefb1afce?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk3ODk&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Featuring travellers from around the world as they explore destinations & adventures.",
  },
  {
    id: "4760062",
    title: "Animals",
    endpoint: `/collections/4760062/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1633005511631-400635e4c8c6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk4MzY&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Featuring wildlife photographers as they explore the beauty of the natural world.",
  },
  {
    id: "4940344",
    title: "History",
    endpoint: `/collections/4940344/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1597704097219-0f6a59def63d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk4ODA&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      " Covering a range of topics, including Black History, historical figures and the World Wars.",
  },
  {
    id: "3356594",
    title: "Health",
    endpoint: `/collections/3356594/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1543585279-0cb57740ef40?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MTk5NjI&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Celebrate healthy mind, body and soul with photos that show new medical discoveries, healthy eating and meditation.",
  },
  {
    id: "4595193",
    title: "Art",
    endpoint: `/collections/4595193/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1627276998207-2679ba885a6f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MjAwMDA&ixlib=rb-1.2.1&q=80&w=1080",
    description: "Beautiful art created by people all arounf the world.",
  },
  {
    id: "1178903",
    title: "Texture",
    endpoint: `/collections/1178903/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1628872523265-acd0bd0141b3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MjAwNDY&ixlib=rb-1.2.1&q=80&w=1080",
    description: "A select collection of interesting patterns and textures.",
  },

  {
    id: "3961155",
    title: "Friends",
    endpoint: `/collections/3961155/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1611352654976-76501e0be13f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MjAxMjM&ixlib=rb-1.2.1&q=80&w=1080",
    description: "Groups of people...sharing life together.",
  },
  {
    id: "70050897",
    title: "Relationship",
    endpoint: `/collections/70050897/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1559930438-0085cd6e9fe5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MjAxNjc&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Images that celebrate the connection between people, from around the world. ",
  },

  {
    id: "3356581",
    title: "Spirituality",
    endpoint: `/collections/3356581/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1582053433976-25c00369fc93?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MjAyNjY&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Exploring themes of love and loss, gratitude and celebration in hopes of understanding life's purpose.",
  },
  {
    id: "1319040",
    title: "Nature",
    endpoint: `/collections/1319040/photos?per_page=30&client_id=${API_KEY}`,
    cover:
      "https://images.unsplash.com/photo-1633622433535-95f04a1520a4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwyNTQxMjB8MHwxfGFsbHx8fHx8fHx8fDE2MzM3MjAzNjc&ixlib=rb-1.2.1&q=80&w=1080",
    description:
      "Let’s celebrate the magic of Mother Earth — with images of everything our planet has to offer.",
  },
];
